export default __webpack_public_path__ + "static/media/logo.099550ec.jpg";